import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getFormData} from "../../models/recurringExpenseModel";
import {createRecurringExpense} from "../../store/recurring-expense-slice";
import {recurringExpenseSchema} from "../../schema/recurringExpenseSchema";
import {fetchNotApplicableList} from "../../store/list-slice";

const RecurringExpenseAdd = () => {
    const dispatch = useDispatch();
    const navigator = useNavigate();

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        createStatus,
        error
    } = useSelector(state => state.recurringExpense);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch])

    const formSubmitHandler = (data) => {
        const updatedData = {
            id: userRole.scopeId,
            ...data
        }

        dispatch(createRecurringExpense({
            ...userRole,
            data: updatedData
        }));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const initialData = getFormData();
    const schema = recurringExpenseSchema({list});

    return (
        <>
            <SubHeader title="Add Recurring Expense">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default RecurringExpenseAdd;